import React, {useCallback, useEffect, useState} from 'react';
import ethereum from 'decentralized/ethereum.js';

export default (props) => {
    const [requests, setRequests] = useState([]);

    useEffect(() => {
        ethereum.guilds.getNewMemberRequests()
            .then(requests => {
                setRequests(requests);
            });
    }, [setRequests]);

    const accept = useCallback((request) => {
        ethereum.guilds.acceptRequestToAddToGuild(request.guildId);
        let  r = [... requests];
        let  i = requests.indexOf(request);
        r.splice(i, 1);
        setRequests(r);
    }, [setRequests, requests]);

    if (requests.length === 0) {
        return (
            <div>
            </div>
        );
    }

    return (
        <div className="guild-requests">
          {requests.map(
              request => <Request accept={() => accept(request)} request={request}/>)}
        </div>
    );
};

const Request = ({request, accept}) => {
    return (
        <div className="guild-request">
          You've been invited to join
          <span className="guild-name">{request.guildName}</span>
          <span onClick={accept} className="accept-button">Accept</span>
        </div>
    );
};
